import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useWizard } from "react-use-wizard";
import createPersistedState from "use-persisted-state";
import NavigateBack from "../../components/navigateBack";
const useTokenState = createPersistedState("token");
const useProfile = createPersistedState("profile");

const ConfirmChangeDoctor = ({ selectedDoctor, queryParamClinicId }) => {
  let history = useHistory();
  const { previousStep } = useWizard();
  const { t } = useTranslation();
  const [profile, setProfile] = useProfile();
  const [token, _] = useTokenState();
  const [isFetchingData, setIsFetchingData] = useState(false);

  const requestConfirmDoctorSwitch = async () => {
    setIsFetchingData(true);

    const SWITCH_DOCTOR_URL = `/api/v1/users/profile/${profile?.patientId}`;
    try {
      const data = {
        doctorId: selectedDoctor?.code,
        clinicId: queryParamClinicId,
      };
      const response = await fetch(`${SWITCH_DOCTOR_URL}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const res = await response.json();

      if (res.status.code !== 200) {
        console.log(response);

        const error = new Error(res.status.message);

        throw error;
      } else {
        // history.push("/my-appointments");
      }
    } catch (err) {
      //   setErrorMessage(err.message);
      //   setIsErrorModalOpen(true);
    }
    setIsFetchingData(false);
  };

  const requestProfileData = async () => {
    const PROFILE_URL = `/api/v1/users/profile/${profile?.patientId}`;

    try {
      const response = await fetch(PROFILE_URL, {
        method: "GET",
        headers: {
          Accept: "application/json; charset=utf-8",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        credentials: "include",
      });
      const data = await response.json();

      if (response.status !== 200) {
        const error = new Error(response.error);
        throw error;
      } else {
        setProfile(data["profile"]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDoctorSwitch = async () => {
    try {
      await requestConfirmDoctorSwitch();
      await requestProfileData();
      history.push("/home");
    } catch (error) {
      console.error("Error in doctor switch process:", error);
    }
  };

  return (
    <>
      <NavigateBack
        onClickHandler={() => {
          previousStep();
        }}
      />
      <div className="body_content py-3">
        <div className="inner_body  text-center d-flex align-items-center ">
          <div className="modal-body">
            <div className="content_modal box_view_app">
              {/* <h4 className="w-100 mt-4 mb-4 headtitle fw-bold text-center">
              {t("appointment.CONFIRMED.message3")} <br />{" "}
              {t("appointment.CONFIRMED.message4")}
            </h4> */}
              <div className="text-center w-100 border-1 pb-0 ">
                <p className="subtitle mb-3">
                  {/* {t("appointment.CONFIRMED.doctor-name")} */}
                  {`You are switching your rheumatologist from ${profile?.doctorName} to ${selectedDoctor?.name}`}
                </p>
              </div>
            </div>
          </div>
          <div className="btn_block bottom_button d-flex justify-content-center p-3">
            <button
              className="w-50 btn btn_outline"
              onClick={() => {
                previousStep();
              }}
            >
              {t("appointment.BUTTON.cancel")}
            </button>
            <button
              className="w-50  btn btn_primary"
              disabled={isFetchingData}
              onClick={() => {
                handleDoctorSwitch();
              }}
            >
              {isFetchingData && (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              )}
              &nbsp;{t("appointment.BUTTON.confirm")}
            </button>
          </div>
        </div>
        {/* <ErrorModal
        isErrorModalOpen={isErrorModalOpen}
        setIsErrorModalOpen={setIsErrorModalOpen}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      /> */}
      </div>
    </>
  );
};

export default ConfirmChangeDoctor;
